
    const data = {"name":"src/core/icons/timer-sand","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M6 2h12v6l-4 4 4 4v6H6v-6l4-4-4-4V2m10 14.5-4-4-4 4V20h8v-3.5m-4-5 4-4V4H8v3.5l4 4M10 6h4v.75l-2 2-2-2V6Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            